var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9a1 1 0 0 1-1-1V3a2.002 2.002 0 0 1 2-2h5a1 1 0 0 1 0 2H4v5a1 1 0 0 1-1 1zM9 31H4a2.002 2.002 0 0 1-2-2v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2zM29 9a1 1 0 0 1-1-1V3h-5a1 1 0 0 1 0-2h5a2.002 2.002 0 0 1 2 2v5a1 1 0 0 1-1 1zM28 31h-5a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5a2.002 2.002 0 0 1-2 2zM16 16.53a6.015 6.015 0 1 1 6.015-6.015A6.022 6.022 0 0 1 16 16.53zM16 6.5a4.015 4.015 0 1 0 4.015 4.015A4.02 4.02 0 0 0 16 6.5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.722 25.5H10.278a2.977 2.977 0 0 1-2.974-2.974 7.925 7.925 0 0 1 7.91-7.938h1.572a7.919 7.919 0 0 1 7.91 7.91 2.983 2.983 0 0 1-2.974 3.002zm-6.508-8.912a5.917 5.917 0 0 0-5.91 5.91.981.981 0 0 0 .974 1.002h11.444a.975.975 0 0 0 .974-.974 5.923 5.923 0 0 0-5.91-5.938z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCard);
export default __webpack_public_path__ + "static/media/user-card.58ba03f862b4b4dc04c42a0fd6079f88.svg";
export { ForwardRef as ReactComponent };